import { create } from "zustand";
import { authenticatedAxios, baseURL } from "../../apis";

const useSubscriptionList = create((set, get) => ({
  // State for the list of users with subscriptions
  subscriptionUsers: {
    results: [],
    page: 1,
    size: 10,
    total: 0,
    has_next: false,
  },
  // State for the list of available subscription plans
  plans: [],
  isLoadingUsers: false,
  isLoadingPlans: false,
  error: null,

  actions: {
    /**
     * Fetches a paginated list of users with subscriptions.
     * Can be filtered by a specific subscription plan.
     * @param {object} params - The query parameters.
     * @param {number} params.page - The page number to fetch.
     * @param {number} params.size - The number of items per page.
     * @param {string} [params.productId] - Optional product ID to filter users by.
     */
    getSubscriptionUsers: async ({ page = 1, size = 10, productId }) => {
      set({ isLoadingUsers: true, error: null });
      try {
        let url = `${baseURL}/api/admin/subscription/users?page=${page}&size=${size}`;
        if (productId) {
          url += `&product_id=${productId}`;
        }

        const { data } = await authenticatedAxios.get(url);

        console.log(data);

        // Ensure the response structure is handled correctly
        set({
          subscriptionUsers: {
            results: data.results || [],
            page: data.page || 1,
            size: data.size || 10,
            total: data.total || 0,
            has_next: data.has_next || false,
          },
        });
      } catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        set({ error: errorMessage });
        console.error("Failed to get subscription users:", err);
      } finally {
        set({ isLoadingUsers: false });
      }
    },

    /**
     * Fetches the list of available subscription plans.
     */
    getPlans: async () => {
      // Prevents re-fetching if plans are already loaded
      if (get().plans.length > 0) return;

      set({ isLoadingPlans: true, error: null });
      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/subscription/plans`,
        );
        // Ensure the data is an array before setting the state
        set({ plans: Array.isArray(data) ? data : [] });
      } catch (err) {
        const errorMessage = err.response?.data?.message || err.message;
        set({ error: errorMessage });
        console.error("Error fetching plans:", err);
      } finally {
        set({ isLoadingPlans: false });
      }
    },
  },
}));

export default useSubscriptionList;
